import { orderBy  } from "lodash";
import dayjs from "dayjs";


//function openContent(genreName) {
//    var i, navcontent, navlinks;
//    navcontent = document.getElementsByClassName("navcontent");
//    for (i = 0; i < navcontent.length; i++) {
//      navcontent[i].style.display = "none";
//    }
//    navlinks = document.getElementsByClassName("navlinks");
//    for (i = 0; i < navlinks.length; i++) {
//      navlinks[i].className = navlinks[i].className.replace("active", "");
//    }
//    document.getElementById(genreName).style.display = "block";
//    return navlinks
//}

function showUsers(members) {

    var html = "";
    //html = html + "<table id='member-table' class='table table-striped table-bordered'>";
    html = html + "<thead>";
    html = html + "  <tr>";
    html = html + "    <th>Nome</th>";
    html = html + "    <th class='cell-center'>Importo</th>";
    html = html + "  </tr>";
    html = html + "</thead>";
    html = html + "<tbody>"

    var keys = Object.keys(members); 
    keys.sort();
    for (var i=0; i<keys.length; i++) { 
        var key = keys[i];
        var value = members[key];
        
        html = html + "<tr>";
        html = html + "<td>" +  value.first_name + " " + value.last_name + " (" + key + ")</td>";
        if (value.balance < 0) {
            html = html + "<td class='negative cell-center'>";
        } else{
            html = html + "<td class='cell-center'>";
        }
        html = html + "" + value.balance + " CHF</td>";
        html = html + "</tr>";
    }

    //html = html + "</tbody></table>";

    //html = html + "<script type='module'>new DataTable('#member-table', { searching: false,  lengthMenu: [5, 10, 100], language: { lengthMenu: '_MENU_' } });</script>"

    return html;
}

function showSelectUsers(members) {

    var html = "";
    html = html + "<label for='member'>Membro</label>";
    html = html + "<input list='member-list' id='member' name='member' />";
    html = html + "<datalist id='member-list'>";

    var keys = Object.keys(members); 
    keys.sort();
    for (var i=0; i<keys.length; i++) { 
        var key = keys[i];
        var value = members[key];
        
        html = html + "<option value='" + key + "'>" +  value.first_name + " " + value.last_name + "</option>"; // (" + key + ")
    }
    html = html + "</datalist>";

    return html;
}



function openTab(elem, tabName) {
    var i, tabcontent, navlinks, tabs;
    //tabcontent = document.getElementsByClassName("tab-content");
    //for (i = 0; i < tabcontent.length; i++) {
    //    tabcontent[i].style.display = "none";
    //}

    navlinks = document.getElementsByClassName("nav-link");
    for (i = 0; i < navlinks.length; i++) {
        navlinks[i].className = navlinks[i].className.replace("active", "");
    }

    tabs = document.getElementsByClassName("tab-pane");
    for (i = 0; i < tabs.length; i++) {
        tabs[i].style.display = "none";
    }

    var curTab = document.getElementById(tabName);
    curTab.style.display = "inline";
    elem.classList.add("active");
    curTab.classList.add("show");
}

function showDayStats(info) {

    var totDrink = 0;
    var totOffer = 0;

    var html = "";
    html = html + "<table id='admin-stats-table' class='table table-striped table-bordered'>";
    html = html + "<thead>";
    html = html + "  <tr>";
    html = html + "    <th>User</th>";
    html = html + "    <th class='cell-center'>Bevuti/Offerti</th>";
    html = html + "  </tr>";
    html = html + "</thead>";
    html = html + "<tbody>"

    var keys = Object.keys(info); 
    keys.sort();

    var winner = ""
    var max = 0;
    for (var i=0; i<keys.length; i++) { 
        var value = info[keys[i]];
        if (value.drink + value.offer > max) {
            winner = value.user;
            max = value.drink + value.offer;
        }
    }


    for (var i=0; i<keys.length; i++) { 
        var key = keys[i];
        var value = info[key];
        
        html = html + "<tr>";
        html = html + "<td>";
        if (value.user == winner) {
            html = html +  "<i class='fas fa-trophy fa-fw me-2'></i>&nbsp";
        }
        html = html +  getUserName(value.user) + "</td>";
        html = html + "<td class='cell-center'>" + value.drink + "/" + value.offer + "</td>";
        html = html + "</tr>";

        totDrink = totDrink + Number(value.drink);
        totOffer = totOffer + Number(value.offer);
    }

    html = html + "</tbody>"
    html = html + "</tbody>";
    html = html + "<tfoot>";
    html = html + "<tr>";
    html = html + "<td>Totali</td>";
    html = html + "<td class='cell-center'>" + totDrink + "/" + totOffer + " = " + (totDrink+totOffer) + "</td>";
    html = html + "</tr>";
    html = html + "</tfoot>";
    html = html + "</table>";

    return html;
}

function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

const capitalize2 = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
  ;

function getUserName(email) {
    var at = email.indexOf("@");
    var prefix = email.substring(0, at);
    var user = prefix.replace(".", " ");
    return capitalize2(user)
}

function showBalance(expenses) {

    var html = "";
    //html = html + "<table id='admin-balance-table' class='table table-striped table-bordered'>";
    html = html + "<thead>";
    html = html + "  <tr>";
    html = html + "    <th>Op</th>";
    html = html + "    <th>Data</th>";
    html = html + "    <th>Descrizione</th>";
    html = html + "    <th class='cell-center'>Imp.</th>";
    html = html + "  </tr>";
    html = html + "</thead>";
    //html = html + "<tbody>"

    var total = 0;

    var sorted = orderBy(expenses, ['created_at'],['asc']);

    for (var i=0; i<sorted.length; i++) { 
        var date = dayjs(sorted[i].created_at).format('YYYY-MM-DD');
        var amount = Number(sorted[i].amount)*10;
        var icon = "fa-usd";
       
        html = html + "<tr>";
        if (Math.sign(amount) < 0) {
            icon = "fa-shopping-cart";
        } 

        html = html + "<td><i class='fas " + icon + " fa-fw me-2'></i></td>";
        html = html + "<td>" +  date + "</td>";
        // html = html + "<td>" +  getUserName(sorted[i].owner) + "</td>";
        html = html + "<td>" +  sorted[i].description + "</td>";
        html = html + "<td class='cell-center'>" + amount/10 + "</td>";
        html = html + "</tr>";

        total = total + amount;
    }

    html = html + "</tbody>";
    html = html + "<tfoot>";
    html = html + "<tr>";
    html = html + "<td colspan='3'>Sum</td>";
    html = html + "<td class='cell-center'>" + total/10 + "</td>";
    html = html + "</tr>";
    html = html + "</tfoot>";
    html = html + "</table>";

    //html = html + "<script type='module'>new DataTable('#admin-balance-table', { searching: false,  lengthMenu: [10, 20, 100], language: { lengthMenu: '_MENU_' } });</script>"


    return html;
}

/**
 * Centralized section management function
 * Shows the specified section and hides all others
 * @param {string} sectionName - Name of the section to show
 * @param {Object} options - Optional configuration
 * @param {boolean} options.skipNavHighlight - Skip navigation highlighting
 * @param {string} options.adminTab - Specific admin tab to show (if section is 'admin')
 * @param {string} options.display - use specific display instead of display=block) 
*/
function showSection(sectionName, options = {}) {
    const sections = [
        'home', 'stats', 'inbox', 'admin', 'news', 'unauthorized',
        'user-content', 'offer-content', 'splash', 'minesweeper'
    ];

    if (sectionName) {
        console.log("🖥️ Showing section '%s' (options: %o)", sectionName, options);
    }
    // Hide all main sections
    sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) {
            element.style.display = 'none';
        }
    });
    
    // Hide all tab panes
    const tabPanes = document.querySelectorAll('.tab-pane');
    tabPanes.forEach(tab => {
        tab.style.display = 'none';
        tab.classList.remove('show', 'active');
    });
    
    // Reset bottom navbar links (navlinks class)
    const bottomNavLinks = document.querySelectorAll('.navlinks');
    bottomNavLinks.forEach(link => {
        link.classList.remove('active');
    });
    
    // Show the requested section
    const targetElement = document.getElementById(sectionName);
    if (targetElement) {
        if (!options.display) {
            targetElement.style.display = 'block';
        } else {
            targetElement.style.display = options.display;
        }
        
        // Handle special cases
        if (sectionName === 'home') {
            // Show main navigation
            document.getElementById('mobile-navbar').style.display = 'block';
            document.getElementById('top-banner').style.display = 'flex';
            
            // Highlight home nav link
            if (!options.skipNavHighlight) {
                const links = document.querySelectorAll('*[data-target="home"]');
                Array.from(links).forEach(link => {
                    link.classList.add('active');
                });
            }
        } else if (sectionName === 'stats') {
            // Show main navigation
            document.getElementById('mobile-navbar').style.display = 'block';
            document.getElementById('top-banner').style.display = 'flex';
            
            // Highlight stats nav link
            if (!options.skipNavHighlight) {
                const links = document.querySelectorAll('*[data-target="stats"]');
                Array.from(links).forEach(link => {
                    link.classList.add('active');
                });
            }
        } else if (sectionName === 'inbox') {
            // Show main navigation
            document.getElementById('mobile-navbar').style.display = 'block';
            document.getElementById('top-banner').style.display = 'flex';
            
            // Highlight inbox nav link
            if (!options.skipNavHighlight) {
                const links = document.querySelectorAll('*[data-target="inbox"]');
                Array.from(links).forEach(link => {
                    link.classList.add('active');
                });
            }
        } else if (sectionName === 'admin') {
            // Check if user has admin role - me is available in main.js context
            // For now, we'll let the main.js handle the admin role check before calling showSection
            // This function will just handle the display logic
            
            // Show main navigation
            document.getElementById('mobile-navbar').style.display = 'block';
            document.getElementById('top-banner').style.display = 'flex';
            
            // Highlight admin nav link
            if (!options.skipNavHighlight) {
                const links = document.querySelectorAll('*[data-target="admin"]');
                Array.from(links).forEach(link => {
                    link.classList.add('active');
                });
            }
            
            // Show default admin tab or specified tab
            const defaultTab = options.adminTab || 'ex-with-icons-tabs-1';
            showAdminTab(defaultTab);
        } else if (sectionName === 'news') {
            // News has special layout - hide main nav, show top nav
            document.getElementById('mobile-navbar').style.display = 'none';
            document.getElementById('top-banner').style.display = 'none';
        } else if (sectionName === 'user-content' || sectionName === 'offer-content') {
            // Content overlays - hide main navigation
            document.getElementById('mobile-navbar').style.display = 'none';
            document.getElementById('top-banner').style.display = 'flex';
        } else if (sectionName === 'unauthorized') {
            // Unauthorized page - hide all navigation
            document.getElementById('mobile-navbar').style.display = 'none';
            document.getElementById('top-banner').style.display = 'none';
        } else if (sectionName === 'minesweeper') {
            document.getElementById('mobile-navbar').style.display = 'block';
            document.getElementById('top-banner').style.display = 'flex';
        }
            
    }
}

/**
 * Shows a specific admin tab within the admin section
 * @param {string} tabName - Name of the tab to show
 */
function showAdminTab(tabName) {
    // Hide all tab panes
    const tabPanes = document.querySelectorAll('.tab-pane');
    tabPanes.forEach(tab => {
        tab.style.display = 'none';
        tab.classList.remove('show', 'active');
    });
    
    // Reset all tab links
    const tabLinks = document.querySelectorAll('.nav-link');
    tabLinks.forEach(link => {
        link.classList.remove('active');
    });
    
    // Show the requested tab
    const targetTab = document.getElementById(tabName);
    if (targetTab) {
        targetTab.style.display = 'inline';
        targetTab.classList.add('show', 'active');
        
        // Highlight the corresponding tab link
        const tabLink = document.querySelector('*[data-target="' + tabName + '"]');
        if (tabLink) tabLink.classList.add('active');
    }
}

/**
 * Shows an overlay content (user-content, offer-content)
 * @param {string} overlayName - Name of the overlay to show
 */
function showOverlay(overlayName) {
    // First hide all the main sections
    showSection();
    
    // Then show the overlay
    const overlayElement = document.getElementById(overlayName);
    if (overlayElement) {
        overlayElement.style.display = 'block';
    }

    document.getElementById('mobile-navbar').style.display = 'none';
    document.getElementById('top-banner').style.display = 'none';
   
}

/**
 * Hides all overlays and returns to the main section
 * @param {string} mainSection - The main section to return to (default: 'home')
 */
function hideOverlay(mainSection = 'home') {
    const overlays = ['user-content', 'offer-content'];
    
    overlays.forEach(overlay => {
        const element = document.getElementById(overlay);
        if (element) {
            element.style.display = 'none';
        }
    });
    
    showSection(mainSection);
    document.getElementById('top-banner').style.display = 'block';
}

export { showUsers, showSelectUsers, openTab, showDayStats, showBalance, showSection, showAdminTab, showOverlay, hideOverlay };
